import 'core-js/stable';
import 'promise-polyfill/src/polyfill';
import Vue from 'vue';
import '@/configured/element-ui';
import '@/app.scss';
import store from '@/store';
import i18n from '@/configured/vue-i18n';
import router from '@/router';
import App from '@/App';
import 'moment/locale/zh-cn';
import 'location-origin';

Vue.config.productionTip = false;

const app = new Vue({
  el: '#app',
  store,
  router,
  i18n: i18n.i18n,
  components: { App },
  template: '<App/>',
});

window.vue = app;
